export default __webpack_public_path__ + "static/media/paysage.4481c059.svg";